module.exports = __webpack_public_path__ + "static/media/phone.7bab931c.svg";